import { DeepLink } from "./DeepLink";

export enum DeepLinkTypes {
    meeting = 'meeting',
    session = 'session',
    event = 'event',
    catalog = 'catalog',
    htmlPage = 'htmlPage',
    userProfile = 'userProfile',
    url = 'url',
    unknow = 'unknow'
}

export interface OpeningDeepLinkParams {
    deepLink: DeepLink;
    backend: string;
    eventId: string;
}

export interface DeepLinkInterface {
    type: DeepLinkTypes;
    data?: DeepLinkDataInterface | any;
}

export interface DeepLinkDataInterface {
    id?: string | number;
    url?: string;
    schemaId?: string;
}

export type DeeplinkParser = (url: URL, params: any) => DeepLink;